// extracted by mini-css-extract-plugin
export default {"layout":"c40950d7b2 _91f41d70a5 _5f247d918e","h_slide":"_333327a566","category":"_0a153aa815 _7462789c11 _5be1a41d11"};